/**
 *
 * Ask
 *
 */

import { mapGetters, mapMutations } from 'vuex';

import { QaSwalMixin } from '@/mixins/QA/QaSwal';
import { QaContentMixin } from '@/mixins/QA/Content';

export const QaMixin = {
  name: 'QaMixin',

  mixins: [QaSwalMixin, QaContentMixin],

  data: () => {
    return {
      isShowQa: false,
      submitting: false,
    };
  },

  computed: {
    ...mapGetters({
      mg_userInfo: 'userInfo',
    }),

    c_isCanOpenQA() {
      return this.mg_userInfo.canPostQA;
    },

    _c_isSubmitDisabled() {
      return (
        !this.mg_userInfo.isCurrentStudent ||
        !this.c_isCanOpenQA ||
        !this.c_isQaContentReady ||
        this.submitting
      );
    },

    c_isSubmitDisabled() {
      return this._c_isSubmitDisabled;
    },
  },

  methods: {
    ...mapMutations('Mixins/QA', {
      mm_CLEAR_QA_STATE: 'CLEAR_QA_STATE',
    }),

    //
    openQaModal() {
      //
    },

    doOpenQA() {
      this.isShowQa = true;
      this.openQaModal();
    },

    openQA() {
      if (!this.mg_userInfo.isCurrentStudent) {
        this.swalPostQAFailure('你是未付费用户不能提问。');
      } else if (!this.c_isCanOpenQA) {
        this.swalNotCanPostQA();
      } else {
        this.doOpenQA();
      }
    },

    //
    async doPostQA() {
      //
    },

    async postQA() {
      try {
        this.submitting = true;
        await Promise.all(this.uploadQaImg());
        await this.doPostQA();
        await this.afterPostQA();
      } catch (e) {
        await this.swalPostQAFailure('问答提交失败，再试一次吧！');
      } finally {
        this.submitting = false;
      }
    },

    //
    doAfterPostQaSuccess() {
      //
    },

    async afterPostQaSuccess() {
      await this.swalPostQASuccess('问答已经发布');
      this.doAfterPostQaSuccess();
      this.closeQA();
      this.clearQA();
    },

    async afterPostQA() {
      await this.afterPostQaSuccess();
    },

    //
    closeQaModal() {
      //
    },

    closeQA() {
      this.closeQaModal();
      this.isShowQa = false;
    },

    doClearQA() {
      //
    },

    clearQA() {
      this.clearQaContent();
      this.doClearQA();
    },
  },

  beforeDestroy() {
    this.mm_CLEAR_QA_STATE();
  },
};

export default QaMixin;
